import { gql } from "@apollo/client";

export const GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD = gql`
query GetTipoProfesionalEspecialidad {
    tipoProfesionalEspecialidad {
        idTipoProfesionalEspecialidad,
        nombre
    }
}`;